const FRANCHISE_THEME_BY_MANAGER = Object.freeze({
  phillyxcommish: Object.freeze({
    id: 'eagles', label: 'Philadelphia Eagles', shortLabel: 'Eagles', mark: '🦅',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/phi.png',
  }),
  tgill55: Object.freeze({
    id: 'steelers', label: 'Pittsburgh Steelers', shortLabel: 'Steelers', mark: '◆',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/pit.png',
  }),
  dominantnation: Object.freeze({
    id: 'saints', label: 'New Orleans Saints', shortLabel: 'Saints', mark: '⚜',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/no.png',
  }),
  eazypickens: Object.freeze({
    id: 'falcons', label: 'Atlanta Falcons', shortLabel: 'Falcons', mark: '🦅',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/atl.png',
  }),
  jcole94: Object.freeze({
    id: 'raiders', label: 'Las Vegas Raiders', shortLabel: 'Raiders', mark: '◈',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/lv.png',
  }),
  jstroud5: Object.freeze({
    id: 'chiefs', label: 'Kansas City Chiefs', shortLabel: 'Chiefs', mark: '🏹',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/kc.png',
  }),
  dirtybirds1993: Object.freeze({
    id: 'falcons', label: 'Atlanta Falcons', shortLabel: 'Falcons', mark: '🦅',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/atl.png',
  }),
  chanthebigcountryman: Object.freeze({
    id: 'falcons', label: 'Atlanta Falcons', shortLabel: 'Falcons', mark: '🦅',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/atl.png',
  }),
  biguzi: Object.freeze({
    id: 'giants', label: 'New York Giants', shortLabel: 'Giants', mark: '🗽',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/nyg.png',
  }),
  alltruejay: Object.freeze({
    id: 'lions', label: 'Detroit Lions', shortLabel: 'Lions', mark: '🦁',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/det.png',
  }),
  allteuejay: Object.freeze({
    id: 'lions', label: 'Detroit Lions', shortLabel: 'Lions', mark: '🦁',
    logoUrl: 'https://a.espncdn.com/i/teamlogos/nfl/500/det.png',
  }),
});

const normalizeManagerName = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

export function resolveFranchiseTheme(user) {
  if (!user || user.guest) return null;

  const identities = [user.display_name, user.username];
  for (const identity of identities) {
    const theme = FRANCHISE_THEME_BY_MANAGER[normalizeManagerName(identity)];
    if (theme) return theme;
  }

  return null;
}
